import React, { useEffect } from "react";
import TableCard from "../common/TableCard";
import { useAppSelector } from "../../store/hooks/StoreHooks";
import { CustomerFeedback, recentProject } from "../../constants/columns/dashboard/recentProjects";
import { useNavigate } from "react-router-dom";
import useProjectFacade from "../../facade/project.Facade";

const RecentProjects: React.FC = () => {
    const { recentData, recentLoading, recentCustomerFeedback, customerFeedbackLoading }: any = useAppSelector((state) => state?.myProjects);
    const { customerEnabled }: any = useAppSelector((state) => state?.auth);
    const navigate = useNavigate();
    const { getUpdatedSelectedProject, fetchRecentCustomerFeedback } = useProjectFacade();

    useEffect(() => {
        fetchRecentCustomerFeedback();
    }, [])

    const handleNavigate = (row: any) => { //parentid and projectID
        let url = (row?.parentId && row?.parentId !== "00000000-0000-0000-0000-000000000000") ? `/project-details/projectID=${row?.parentId}/caseID=${row?.projectId}` : `/project-details/projectID=${row?.projectId}`;
        navigate(url);
        // (async () => {
        // await getUpdatedSelectedProject({
        //     projectID: row?.parentId ?? row?.projectID,
        //     projectName: row?.projectName,
        //     caseID: !row?.parentId ? row?.projectID : ""
        // });
        // })()
    };

    return (
        <>
            {
                customerEnabled ?
                    <TableCard
                        title={"Recent Projects"}
                        columns={[
                            ...recentProject({
                                handleNavigate: handleNavigate
                            })
                        ]}
                        data={recentData}
                        isLoading={recentLoading}
                        errorMessage="No recent projects"
                    />
                    : <TableCard
                        title={"Recent customer feedbacks"}
                        columns={[
                            ...CustomerFeedback({
                                handleNavigate: handleNavigate
                            })
                        ]}
                        data={recentCustomerFeedback}
                        isLoading={customerFeedbackLoading}
                        errorMessage="No recent feedbacks"
                    />
            }
        </>

    );
};

export default RecentProjects;
